module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('div', [_c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [(_vm.level === 'ROOT') ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/region"
    }
  }, [_c('span', [_vm._v("Region")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/wilayah"
    }
  }, [_c('span', [_vm._v("Wilayah")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/area/+/+"
    }
  }, [_c('span', [_vm._v("Area")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/cabang"
    }
  }, [_c('span', [_vm._v("Cabang")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pegawai_level"
    }
  }, [_vm._v(" Level / Jabatan")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pegawai"
    }
  }, [_vm._v(" Data")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/absensi"
    }
  }, [_vm._v(" Absensi")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/barang_satuan"
    }
  }, [_vm._v(" Satuan")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/barang_kelompok"
    }
  }, [_vm._v(" Kelompok")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/barang"
    }
  }, [_vm._v(" Data")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/barang_jadi"
    }
  }, [_vm._v(" Brg Jadi (FG)")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/barang_jadi_bahan"
    }
  }, [_vm._v(" B.O.M")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/barang_accurate"
    }
  }, [_vm._v(" ACCURATE")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/menu_kategori"
    }
  }, [_vm._v(" Kategori")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/menu"
    }
  }, [_vm._v(" Data")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/investor"
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('span', [_vm._v("Investor")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_jenis"
    }
  }, [_vm._v(" Jenis")])], 1) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_admin"
    }
  }, [_vm._v(" Admin")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko"
    }
  }, [_vm._v(" Data")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/barang_toko"
    }
  }, [_vm._v(" Barang")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_pegawai"
    }
  }, [_vm._v(" Pegawai")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_device"
    }
  }, [_vm._v(" Device POS")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/menu_toko"
    }
  }, [_vm._v(" Menu Toko")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/investor_toko"
    }
  }, [_vm._v(" Investor Toko")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pemesanan_barang"
    }
  }, [_vm._v("Pemesanan Barang")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/penjualan"
    }
  }, [_vm._v("Penjualan")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/penjualan_input"
    }
  }, [_vm._v("Input Penjualan")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/laporan_harian"
    }
  }, [_vm._v("Laporan Penjualan")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_harian"
    }
  }, [_vm._v("Pengeluaran Harian")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pnl"
    }
  }, [_vm._v("PNL")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/kacab_fee"
    }
  }, [_vm._v("Fee Kacab")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_dashboard"
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_infaq"
    }
  }, [_vm._v("Infaq")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/penerimaan_barang"
    }
  }, [_vm._v("Penerimaan Barang")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_target"
    }
  }, [_vm._v("Target")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_pinjam_barang"
    }
  }, [_vm._v("Pinjam Barang")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_bulanan_pilihan"
    }
  }, [_vm._v(" Pilihan")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_bulanan_cogs"
    }
  }, [_vm._v(" COGS")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_bulanan_opr"
    }
  }, [_vm._v(" OPR")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_bulanan_sum"
    }
  }, [_vm._v(" Summary")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(6), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/saving_pilihan"
    }
  }, [_vm._v(" Pilihan")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/saving"
    }
  }, [_vm._v(" Data")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(7), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/cutoff_jenis"
    }
  }, [_c('span', [_vm._v("Jenis")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/cutoff_detail"
    }
  }, [_c('span', [_vm._v("Detail")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(8), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/armada"
    }
  }, [_c('span', [_vm._v("Armada")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level === 'ROOT') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengiriman"
    }
  }, [_c('span', [_vm._v("Data")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  }), _vm._v(" "), _c('span', [_vm._v("Toko / Store")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_device"
    }
  }, [_c('i', {
    staticClass: "ti-tablet"
  }), _vm._v(" "), _c('span', [_vm._v("Device POS")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/barang_toko"
    }
  }, [_c('i', {
    staticClass: "ti-dropbox"
  }), _vm._v(" "), _c('span', [_vm._v("Barang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN') !== -1) ? _c('li', [_vm._m(9), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pegawai"
    }
  }, [_vm._v(" Master Data")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_pegawai"
    }
  }, [_vm._v(" Per Toko")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(10), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/barang_jadi"
    }
  }, [_vm._v(" Barang Jadi")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/menu"
    }
  }, [_vm._v(" Master Data")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/menu_toko"
    }
  }, [_vm._v(" Per Toko")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/pemesanan_barang"
    }
  }, [_c('i', {
    staticClass: "ti-pencil"
  }), _vm._v(" "), _c('span', [_vm._v("Pemesanan Barang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/penerimaan_barang"
    }
  }, [_c('i', {
    staticClass: "ti-truck"
  }), _vm._v(" "), _c('span', [_vm._v("Penerimaan Barang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_pinjam_barang"
    }
  }, [_c('i', {
    staticClass: "ti-reload"
  }), _vm._v(" "), _c('span', [_vm._v("Pinjam Barang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(11), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/penjualan"
    }
  }, [_vm._v(" Data")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/penjualan_input"
    }
  }, [_vm._v(" Input")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(12), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_harian"
    }
  }, [_vm._v(" Harian")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_bulanan_cogs"
    }
  }, [_vm._v(" Bulanan COGS")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_bulanan_opr"
    }
  }, [_vm._v(" Bulanan OPR")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/saving"
    }
  }, [_c('i', {
    staticClass: "ti-wallet"
  }), _vm._v(" "), _c('span', [_vm._v("Saving")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/laporan_harian"
    }
  }, [_c('i', {
    staticClass: "ti-write"
  }), _vm._v(" "), _c('span', [_vm._v("Laporan")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/pnl"
    }
  }, [_c('i', {
    staticClass: "ti-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("PnL")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('ADMIN TOKO') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_dashboard"
    }
  }, [_c('i', {
    staticClass: "ti-pie-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('BOD') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/penjualan"
    }
  }, [_c('i', {
    staticClass: "ti-shopping-cart"
  }), _vm._v(" "), _c('span', [_vm._v("Penjualan")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('BOD') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_dashboard"
    }
  }, [_c('i', {
    staticClass: "ti-pie-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('BOD') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/pnl"
    }
  }, [_c('i', {
    staticClass: "ti-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("PnL")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  }), _vm._v(" "), _c('span', [_vm._v("Toko / Store")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/barang_toko"
    }
  }, [_c('i', {
    staticClass: "ti-dropbox"
  }), _vm._v(" "), _c('span', [_vm._v("Barang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_pegawai"
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('span', [_vm._v("Pegawai")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/penerimaan_barang"
    }
  }, [_c('i', {
    staticClass: "ti-truck"
  }), _vm._v(" "), _c('span', [_vm._v("Penerimaan Barang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_pinjam_barang"
    }
  }, [_c('i', {
    staticClass: "ti-reload"
  }), _vm._v(" "), _c('span', [_vm._v("Pinjam Barang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/penjualan"
    }
  }, [_c('i', {
    staticClass: "ti-shopping-cart"
  }), _vm._v(" "), _c('span', [_vm._v("Penjualan")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(13), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_harian"
    }
  }, [_vm._v(" Harian")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_bulanan_cogs"
    }
  }, [_vm._v(" Bulanan COGS")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_bulanan_opr"
    }
  }, [_vm._v(" Bulanan OPR")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/saving"
    }
  }, [_c('i', {
    staticClass: "ti-wallet"
  }), _vm._v(" "), _c('span', [_vm._v("Saving")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/laporan_harian"
    }
  }, [_c('i', {
    staticClass: "ti-write"
  }), _vm._v(" "), _c('span', [_vm._v("Laporan")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/pnl"
    }
  }, [_c('i', {
    staticClass: "ti-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("PnL")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('KACAB') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_dashboard"
    }
  }, [_c('i', {
    staticClass: "ti-pie-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/cabang"
    }
  }, [_c('i', {
    staticClass: "ti-location-pin"
  }), _vm._v(" "), _c('span', [_vm._v("Cabang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  }), _vm._v(" "), _c('span', [_vm._v("Toko / Store")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/barang_toko"
    }
  }, [_c('i', {
    staticClass: "ti-dropbox"
  }), _vm._v(" "), _c('span', [_vm._v("Barang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_pegawai"
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('span', [_vm._v("Pegawai")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/penerimaan_barang"
    }
  }, [_c('i', {
    staticClass: "ti-truck"
  }), _vm._v(" "), _c('span', [_vm._v("Penerimaan Barang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_pinjam_barang"
    }
  }, [_c('i', {
    staticClass: "ti-reload"
  }), _vm._v(" "), _c('span', [_vm._v("Pinjam Barang")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/penjualan"
    }
  }, [_c('i', {
    staticClass: "ti-shopping-cart"
  }), _vm._v(" "), _c('span', [_vm._v("Penjualan")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(14), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_harian"
    }
  }, [_vm._v(" Harian")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_bulanan_cogs"
    }
  }, [_vm._v(" Bulanan COGS")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pengeluaran_bulanan_opr"
    }
  }, [_vm._v(" Bulanan OPR")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/saving"
    }
  }, [_c('i', {
    staticClass: "ti-wallet"
  }), _vm._v(" "), _c('span', [_vm._v("Saving")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/laporan_harian"
    }
  }, [_c('i', {
    staticClass: "ti-write"
  }), _vm._v(" "), _c('span', [_vm._v("Laporan")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/pnl"
    }
  }, [_c('i', {
    staticClass: "ti-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("PnL")])])], 1) : _vm._e(), _vm._v(" "), (_vm.level.indexOf('AM') !== -1) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/toko_dashboard"
    }
  }, [_c('i', {
    staticClass: "ti-pie-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "200px"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-location-pin "
  }), _vm._v(" "), _c('span', [_vm._v("Lokasi")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('span', [_vm._v("Pegawai")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-dropbox"
  }), _vm._v(" "), _c('span', [_vm._v("Barang")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-layout-grid3"
  }), _vm._v(" "), _c('span', [_vm._v(" Menu POS")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  }), _vm._v(" "), _c('span', [_vm._v("Toko")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-money"
  }), _vm._v(" "), _c('span', [_vm._v("Pengeluaran")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-wallet"
  }), _vm._v(" "), _c('span', [_vm._v("Saving")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "el-icon-date "
  }), _vm._v(" "), _c('span', [_vm._v("Cutoff")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-truck"
  }), _vm._v(" "), _c('span', [_vm._v("Pengiriman")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('span', [_vm._v("Pegawai")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-layout-grid3"
  }), _vm._v(" "), _c('span', [_vm._v("Menu")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-shopping-cart"
  }), _vm._v(" "), _c('span', [_vm._v("Penjualan")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-shopping-cart-full"
  }), _vm._v(" "), _c('span', [_vm._v("Pengeluaran")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-shopping-cart-full"
  }), _vm._v(" "), _c('span', [_vm._v("Pengeluaran")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-shopping-cart-full"
  }), _vm._v(" "), _c('span', [_vm._v("Pengeluaran")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a53a941!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = 1401
// module chunks = 2